 import { axiosPost } from "../AxiosRequests";
 import { GetAllUserListByClientIdAndClientSecret } from '../ApiEndPoints';
export default class AppUserDetailServices {

    
    async GetAllUserListByClientIdAndClientSecret(request) {
        return axiosPost(GetAllUserListByClientIdAndClientSecret, request);
    }

}